/*
  Marcel Afters, SETS-10X (25 Sep 2026). "Shop the set" on the product page (snippets/ma-set-pdp.liquid) and
  "Complete the set" in the cart drawer (snippets/ma-set-nudge.liquid).
  - Adds go through the theme's CartLinesUpdateEvent, the same path as ma-cards.js, so the drawer re-renders and opens.
  - State is read from the DOM on every action: the product section can morph after a variant change.
*/
(function () {
  if (window.__maSets10x) return;
  window.__maSets10x = true;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var routes = (window.Theme && Theme.routes) || {};

  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    var v = cents / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: cur,
        minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2
      }).format(v);
    } catch (e) { return '$' + (v % 1 ? v.toFixed(2) : v); }
  }

  function sectionIds() {
    var ids = [];
    [].forEach.call(document.querySelectorAll('cart-items-component'), function (n) {
      if (n.dataset && n.dataset.sectionId) ids.push(n.dataset.sectionId);
    });
    return ids;
  }

  async function addLines(source, lines, tag) {
    var mod = null, def = null;
    try { mod = await import('@shopify/events'); } catch (e) { mod = null; }
    if (mod && mod.CartLinesUpdateEvent) {
      try {
        def = mod.CartLinesUpdateEvent.createPromise();
        source.dispatchEvent(new mod.CartLinesUpdateEvent({
          action: 'add', context: 'product',
          lines: lines.map(function (l) { return { merchandiseId: String(l.id), quantity: 1 }; }),
          promise: def.promise
        }));
      } catch (e) { def = null; }
    }
    var body = { items: lines.map(function (l) { return { id: Number(l.id), quantity: 1 }; }) };
    var ids = sectionIds();
    if (ids.length) body.sections = ids.join(',');
    var ok = false, json = null, cart = null;
    try {
      var res = await fetch(routes.cart_add_url || (ROOT + 'cart/add.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
        body: JSON.stringify(body)
      });
      json = await res.json();
      ok = res.ok && !json.status;
      try {
        var cr = await fetch((routes.cart_url || (ROOT + 'cart')) + '.json', { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
        cart = await cr.json();
      } catch (e2) { cart = null; }
    } catch (e) { ok = false; json = { description: 'Could not reach the bag. Try again.' }; }
    if (def) {
      if (cart) {
        def.resolve({
          cart: mod.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail: { items: cart.items, source: tag, sourceId: tag, itemCount: lines.length, sections: json && json.sections, didError: !ok }
        });
      } else { def.reject(new Error('cart unavailable')); }
    }
    return { ok: ok, json: json, handled: !!def };
  }

  /* ---------- product page module ---------- */
  function data(host) {
    if (!host._d) {
      try { host._d = JSON.parse(host.querySelector('[data-ma-set-json]').textContent); } catch (e) { host._d = null; }
    }
    return host._d;
  }
  function colourOf(host) {
    var on = host.querySelector('[data-ma-set-col][aria-checked="true"]');
    var d = data(host);
    return on ? on.getAttribute('data-ma-set-col') : (d && d.colour);
  }
  function find(piece, c, s) {
    for (var i = 0; i < piece.variants.length; i++) {
      var v = piece.variants[i];
      if (v.c === c && (s == null || v.s === s)) return v;
    }
    return null;
  }
  function firstAvail(piece, c) {
    for (var i = 0; i < piece.variants.length; i++) {
      var v = piece.variants[i];
      if (v.c === c && v.a) return v;
    }
    return find(piece, c, null);
  }

  function paint(host) {
    var d = data(host);
    if (!d) return;
    var c = colourOf(host);
    var rows = host.querySelectorAll('[data-ma-set-piece]');
    var total = 0, bottomPrice = 0, bothInStock = true;
    d.pieces.forEach(function (piece, i) {
      var row = rows[i];
      if (!row) return;
      var sel = row.querySelector('[data-ma-set-size]');
      var chosen = sel ? sel.value : '';
      [].forEach.call(sel ? sel.options : [], function (o) {
        if (!o.value) return;
        var v = find(piece, c, o.value);
        var avail = !!(v && v.a);
        o.disabled = !avail;
        o.textContent = o.value + (avail ? '' : ' · sold out');
      });
      if (sel && chosen) {
        var cv = find(piece, c, chosen);
        if (!cv || !cv.a) sel.value = '';
      }
      var v = (sel && sel.value) ? find(piece, c, sel.value) : firstAvail(piece, c);
      if (!firstAvail(piece, c) || !firstAvail(piece, c).a) bothInStock = false;
      if (v) {
        total += v.p;
        if (i === 1) bottomPrice = v.p;
        var pr = row.querySelector('[data-ma-set-price]');
        if (pr) pr.textContent = money(v.p);
        var img = row.querySelector('.ma-set__img img');
        if (img && v.i && img.getAttribute('data-src-c') !== c) {
          img.removeAttribute('srcset');
          img.src = v.i;
          img.setAttribute('data-src-c', c);
        }
      }
    });
    /* 27 Sep (mobile QA): one discount story everywhere. Two pieces trigger the automatic
       "2+ pieces, 10% off" (the only multi-buy tier a set reaches), so Together shows that price,
       with the undiscounted sum struck through. */
    var net = total; /* CLOSEOUT 27 Sep: full price shown, no promo (was total * 0.9) */
    [].forEach.call(host.querySelectorAll('[data-ma-set-total]'), function (n) { n.textContent = money(net); });
    [].forEach.call(host.querySelectorAll('[data-ma-set-was]'), function (n) { n.textContent = money(total); });
    var bar = host._bar || host.querySelector('[data-ma-setbar]');
    if (bar) {
      [].forEach.call(bar.querySelectorAll('[data-ma-set-total]'), function (n) { n.textContent = money(net); });
    }
    var cn = host.querySelector('[data-ma-set-colour]');
    if (cn) cn.textContent = c;
    if (bar) {
      var nm = bar.querySelector('[data-ma-setbar-name]');
      var hn = host.querySelector('.ma-set__name');
      if (nm && hn) nm.textContent = hn.textContent;
    }
    host._inStock = bothInStock;
  }

  function msg(host, text, err) {
    var m = host.querySelector('[data-ma-set-msg]');
    if (!m) return;
    m.textContent = text || '';
    m.classList.toggle('is-err', !!err);
  }

  async function addSet(host, btn) {
    if (host._busy) return;
    var d = data(host);
    if (!d) return;
    var c = colourOf(host);
    var rows = host.querySelectorAll('[data-ma-set-piece]');
    var lines = [], missing = null;
    d.pieces.forEach(function (piece, i) {
      var sel = rows[i] && rows[i].querySelector('[data-ma-set-size]');
      if (sel) sel.classList.remove('is-missing');
      var v = sel && sel.value ? find(piece, c, sel.value) : null;
      if (!v || !v.a) {
        if (sel) sel.classList.add('is-missing');
        if (!missing) missing = sel;
      } else lines.push(v);
    });
    if (missing) {
      msg(host, 'Choose a size for each piece.', true);
      if (btn && btn.closest('[data-ma-setbar]')) host.scrollIntoView({ behavior: 'smooth', block: 'center' });
      try { missing.focus({ preventScroll: !!(btn && btn.closest('[data-ma-setbar]')) }); } catch (e) { missing.focus(); }
      return;
    }
    host._busy = true;
    var btns = [].slice.call(host.querySelectorAll('[data-ma-set-add]'));
    if (host._bar) btns = btns.concat([].slice.call(host._bar.querySelectorAll('[data-ma-set-add]')));
    btns.forEach(function (b) { b.setAttribute('aria-busy', 'true'); b.textContent = 'Adding'; });
    msg(host, '');
    var r = await addLines(host, lines, 'ma-set');
    host._busy = false;
    btns.forEach(function (b) { b.removeAttribute('aria-busy'); b.textContent = 'Add the set'; });
    if (r.ok) {
      msg(host, 'The set is in your bag.');
      if (!r.handled) window.location.href = routes.cart_url || (ROOT + 'cart');
    } else {
      msg(host, (r.json && (r.json.description || r.json.message)) || 'Could not add the set. Try again.', true);
    }
  }

  function syncFromPicker(host) {
    var vp = document.querySelector('variant-picker');
    if (!vp || typeof vp.getAllSelectedOptions !== 'function') return;
    var opts = vp.getAllSelectedOptions() || [];
    var col = null, size = null;
    opts.forEach(function (o) {
      var n = String(o.name || '').toLowerCase();
      if (n === 'color' || n === 'colour') col = o.value;
      if (n === 'size') size = o.value;
    });
    if (col) {
      var chip = null;
      [].forEach.call(host.querySelectorAll('[data-ma-set-col]'), function (b) {
        if (b.getAttribute('data-ma-set-col') === col) chip = b;
      });
      if (chip) {
        [].forEach.call(host.querySelectorAll('[data-ma-set-col]'), function (b) { b.setAttribute('aria-checked', b === chip ? 'true' : 'false'); });
      }
    }
    if (size) {
      var cur = host.getAttribute('data-current');
      var row = host.querySelector('[data-ma-set-piece="' + cur + '"]');
      var sel = row && row.querySelector('[data-ma-set-size]');
      if (sel) {
        var had = [].some.call(sel.options, function (o) { return o.value === size; });
        if (had) sel.value = size;
      }
    }
    paint(host);
  }

  /* sticky set bar, phones only */
  function barLoop(host) {
    var bar = host.querySelector('[data-ma-setbar]');
    if (!bar) return;
    document.body.appendChild(bar);
    host._bar = bar;
    bar._host = host;
    var mq = window.matchMedia('(max-width: 749px)');
    var ticking = false;
    function place() {
      ticking = false;
      if (!mq.matches || !host.isConnected || host._inStock === false) { bar.hidden = true; return; }
      var r = host.getBoundingClientRect();
      var gone = r.bottom < 0;
      bar.hidden = !gone;
      if (!gone) return;
      var nb = document.querySelector('sticky-add-to-cart .sticky-add-to-cart__bar');
      var off = 0;
      if (nb) {
        var nr = nb.getBoundingClientRect();
        var vis = nr.height > 0 && nr.top < window.innerHeight && getComputedStyle(nb).visibility !== 'hidden';
        if (vis) off = Math.max(0, window.innerHeight - nr.top);
      }
      bar.style.setProperty('--ma-setbar-b', off + 'px');
      bar.style.setProperty('--ma-setbar-safe', off ? '0px' : 'env(safe-area-inset-bottom)');
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(place); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    place();
  }

  function init(host) {
    if (host._init) return;
    host._init = true;
    paint(host);
    barLoop(host);
  }

  function initAll() {
    [].forEach.call(document.querySelectorAll('ma-set-pdp'), init);
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;
    var col = t.closest('[data-ma-set-col]');
    if (col) {
      var host = col.closest('ma-set-pdp');
      [].forEach.call(host.querySelectorAll('[data-ma-set-col]'), function (b) { b.setAttribute('aria-checked', b === col ? 'true' : 'false'); });
      msg(host, '');
      paint(host);
      return;
    }
    var add = t.closest('[data-ma-set-add]');
    if (add) {
      var h = add.closest('ma-set-pdp') || (add.closest('[data-ma-setbar]') || {})._host;
      if (h) { e.preventDefault(); addSet(h, add); }
      return;
    }
    var nud = t.closest('[data-ma-setn-add]');
    if (nud) {
      e.preventDefault();
      if (nud.getAttribute('aria-busy') === 'true') return;
      nud.setAttribute('aria-busy', 'true');
      nud.textContent = 'Adding';
      addLines(nud, [{ id: nud.getAttribute('data-ma-setn-add') }], 'ma-set-nudge').then(function (r) {
        if (!r.ok) {
          nud.removeAttribute('aria-busy');
          nud.textContent = (r.json && r.json.description) ? 'Sold out' : 'Add';
        } else if (!r.handled) {
          window.location.href = routes.cart_url || (ROOT + 'cart');
        }
      });
    }
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;
    var sel = t.closest('[data-ma-set-size]');
    if (sel) {
      sel.classList.remove('is-missing');
      var host = sel.closest('ma-set-pdp');
      msg(host, '');
      paint(host);
      return;
    }
    if (t.closest('variant-picker')) {
      setTimeout(function () {
        [].forEach.call(document.querySelectorAll('ma-set-pdp'), syncFromPicker);
      }, 0);
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
})();
